/* tslint:disable */
/* eslint-disable */
/**
 * gateway-ilots-chaleur API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: unspecified
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BoundingBox
 */
export interface BoundingBox {
    /**
     * 
     * @type {Point}
     * @memberof BoundingBox
     */
    'southwest'?: Point;
    /**
     * 
     * @type {Point}
     * @memberof BoundingBox
     */
    'northeast'?: Point;
}
/**
 * 
 * @export
 * @interface EntrySetInner
 */
export interface EntrySetInner {
    /**
     * 
     * @type {string}
     * @memberof EntrySetInner
     */
    'key'?: string;
    /**
     * 
     * @type {JsonElement}
     * @memberof EntrySetInner
     */
    'value'?: JsonElement;
}
/**
 * 
 * @export
 * @interface Feature
 */
export interface Feature {
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    'type'?: string;
    /**
     * 
     * @type {BoundingBox}
     * @memberof Feature
     */
    'bbox'?: BoundingBox;
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    'id'?: string;
    /**
     * 
     * @type {object}
     * @memberof Feature
     */
    'geometry'?: object;
    /**
     * 
     * @type {JsonObject}
     * @memberof Feature
     */
    'properties'?: JsonObject;
}
/**
 * 
 * @export
 * @interface IlotChaleur
 */
export interface IlotChaleur {
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'irisName'?: string;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'irisCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'inseeCom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'nomCom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'nomDep'?: string;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'codeDep'?: string;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'nomEpci'?: string;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'codeEpci'?: string;
    /**
     * 
     * @type {number}
     * @memberof IlotChaleur
     */
    'hre'?: number;
    /**
     * 
     * @type {number}
     * @memberof IlotChaleur
     */
    'bur'?: number;
    /**
     * 
     * @type {number}
     * @memberof IlotChaleur
     */
    'are'?: number;
    /**
     * 
     * @type {number}
     * @memberof IlotChaleur
     */
    'ror'?: number;
    /**
     * 
     * @type {number}
     * @memberof IlotChaleur
     */
    'bsr'?: number;
    /**
     * 
     * @type {number}
     * @memberof IlotChaleur
     */
    'war'?: number;
    /**
     * 
     * @type {number}
     * @memberof IlotChaleur
     */
    'ver'?: number;
    /**
     * 
     * @type {number}
     * @memberof IlotChaleur
     */
    'vhr'?: number;
    /**
     * 
     * @type {number}
     * @memberof IlotChaleur
     */
    'lczInt'?: number;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'lcz'?: string;
    /**
     * 
     * @type {string}
     * @memberof IlotChaleur
     */
    'feature'?: string;
    /**
     * 
     * @type {Feature}
     * @memberof IlotChaleur
     */
    'featureToGeoJson'?: Feature;
}
/**
 * 
 * @export
 * @interface JsonElement
 */
export interface JsonElement {
    /**
     * 
     * @type {boolean}
     * @memberof JsonElement
     */
    'jsonArray'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonElement
     */
    'jsonObject'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonElement
     */
    'jsonPrimitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonElement
     */
    'jsonNull'?: boolean;
    /**
     * 
     * @type {JsonObject}
     * @memberof JsonElement
     */
    'asJsonObject'?: JsonObject;
    /**
     * 
     * @type {Array<JsonElement>}
     * @memberof JsonElement
     */
    'asJsonArray'?: Array<JsonElement>;
    /**
     * 
     * @type {JsonPrimitive}
     * @memberof JsonElement
     */
    'asJsonPrimitive'?: JsonPrimitive;
    /**
     * 
     * @type {JsonNull}
     * @memberof JsonElement
     */
    'asJsonNull'?: JsonNull;
    /**
     * 
     * @type {boolean}
     * @memberof JsonElement
     */
    'asBoolean'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JsonElement
     */
    'asNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonElement
     */
    'asString'?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonElement
     */
    'asDouble'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonElement
     */
    'asFloat'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonElement
     */
    'asLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonElement
     */
    'asInt'?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonElement
     */
    'asByte'?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonElement
     * @deprecated
     */
    'asCharacter'?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonElement
     */
    'asBigDecimal'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonElement
     */
    'asBigInteger'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonElement
     */
    'asShort'?: number;
}
/**
 * 
 * @export
 * @interface JsonNull
 */
export interface JsonNull {
    /**
     * 
     * @type {boolean}
     * @memberof JsonNull
     */
    'jsonArray'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonNull
     */
    'jsonObject'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonNull
     */
    'jsonPrimitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonNull
     */
    'jsonNull'?: boolean;
    /**
     * 
     * @type {JsonObject}
     * @memberof JsonNull
     */
    'asJsonObject'?: JsonObject;
    /**
     * 
     * @type {Array<JsonElement>}
     * @memberof JsonNull
     */
    'asJsonArray'?: Array<JsonElement>;
    /**
     * 
     * @type {JsonPrimitive}
     * @memberof JsonNull
     */
    'asJsonPrimitive'?: JsonPrimitive;
    /**
     * 
     * @type {JsonNull}
     * @memberof JsonNull
     */
    'asJsonNull'?: JsonNull;
    /**
     * 
     * @type {boolean}
     * @memberof JsonNull
     */
    'asBoolean'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JsonNull
     */
    'asNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonNull
     */
    'asString'?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonNull
     */
    'asDouble'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonNull
     */
    'asFloat'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonNull
     */
    'asLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonNull
     */
    'asInt'?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonNull
     */
    'asByte'?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonNull
     * @deprecated
     */
    'asCharacter'?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonNull
     */
    'asBigDecimal'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonNull
     */
    'asBigInteger'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonNull
     */
    'asShort'?: number;
}
/**
 * 
 * @export
 * @interface JsonObject
 */
export interface JsonObject {
    /**
     * 
     * @type {boolean}
     * @memberof JsonObject
     */
    'jsonArray'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonObject
     */
    'jsonObject'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonObject
     */
    'jsonPrimitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonObject
     */
    'jsonNull'?: boolean;
    /**
     * 
     * @type {JsonObject}
     * @memberof JsonObject
     */
    'asJsonObject'?: JsonObject;
    /**
     * 
     * @type {Array<JsonElement>}
     * @memberof JsonObject
     */
    'asJsonArray'?: Array<JsonElement>;
    /**
     * 
     * @type {JsonPrimitive}
     * @memberof JsonObject
     */
    'asJsonPrimitive'?: JsonPrimitive;
    /**
     * 
     * @type {JsonNull}
     * @memberof JsonObject
     */
    'asJsonNull'?: JsonNull;
    /**
     * 
     * @type {boolean}
     * @memberof JsonObject
     */
    'asBoolean'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JsonObject
     */
    'asNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonObject
     */
    'asString'?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonObject
     */
    'asDouble'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonObject
     */
    'asFloat'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonObject
     */
    'asLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonObject
     */
    'asInt'?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonObject
     */
    'asByte'?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonObject
     * @deprecated
     */
    'asCharacter'?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonObject
     */
    'asBigDecimal'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonObject
     */
    'asBigInteger'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonObject
     */
    'asShort'?: number;
    /**
     * 
     * @type {LinkedTreeMapStringJsonElement}
     * @memberof JsonObject
     */
    'members'?: LinkedTreeMapStringJsonElement;
    /**
     * 
     * @type {boolean}
     * @memberof JsonObject
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface JsonPrimitive
 */
export interface JsonPrimitive {
    /**
     * 
     * @type {boolean}
     * @memberof JsonPrimitive
     */
    'jsonArray'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPrimitive
     */
    'jsonObject'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPrimitive
     */
    'jsonPrimitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPrimitive
     */
    'jsonNull'?: boolean;
    /**
     * 
     * @type {JsonObject}
     * @memberof JsonPrimitive
     */
    'asJsonObject'?: JsonObject;
    /**
     * 
     * @type {Array<JsonElement>}
     * @memberof JsonPrimitive
     */
    'asJsonArray'?: Array<JsonElement>;
    /**
     * 
     * @type {JsonPrimitive}
     * @memberof JsonPrimitive
     */
    'asJsonPrimitive'?: JsonPrimitive;
    /**
     * 
     * @type {JsonNull}
     * @memberof JsonPrimitive
     */
    'asJsonNull'?: JsonNull;
    /**
     * 
     * @type {any}
     * @memberof JsonPrimitive
     */
    'value'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPrimitive
     */
    'boolean'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPrimitive
     */
    'asBoolean'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPrimitive
     */
    'number'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JsonPrimitive
     */
    'asNumber'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPrimitive
     */
    'string'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JsonPrimitive
     */
    'asString'?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonPrimitive
     */
    'asDouble'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonPrimitive
     */
    'asBigDecimal'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonPrimitive
     */
    'asBigInteger'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonPrimitive
     */
    'asFloat'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonPrimitive
     */
    'asLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonPrimitive
     */
    'asShort'?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonPrimitive
     */
    'asInt'?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonPrimitive
     */
    'asByte'?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonPrimitive
     * @deprecated
     */
    'asCharacter'?: string;
}
/**
 * 
 * @export
 * @interface LinkedTreeMapStringJsonElement
 */
export interface LinkedTreeMapStringJsonElement {
    [key: string]: JsonElement | any;

    /**
     * 
     * @type {object}
     * @memberof LinkedTreeMapStringJsonElement
     */
    'comparator'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof LinkedTreeMapStringJsonElement
     */
    'allowNullValues'?: boolean;
    /**
     * 
     * @type {NodeStringJsonElement}
     * @memberof LinkedTreeMapStringJsonElement
     */
    'root'?: NodeStringJsonElement;
    /**
     * 
     * @type {number}
     * @memberof LinkedTreeMapStringJsonElement
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof LinkedTreeMapStringJsonElement
     */
    'modCount'?: number;
    /**
     * 
     * @type {NodeStringJsonElement}
     * @memberof LinkedTreeMapStringJsonElement
     */
    'header'?: NodeStringJsonElement;
    /**
     * 
     * @type {Set<EntrySetInner>}
     * @memberof LinkedTreeMapStringJsonElement
     */
    'entrySet'?: Set<EntrySetInner>;
    /**
     * 
     * @type {Set<any>}
     * @memberof LinkedTreeMapStringJsonElement
     */
    'keySet'?: Set<any>;
}
/**
 * 
 * @export
 * @interface NodeStringJsonElement
 */
export interface NodeStringJsonElement {
    /**
     * 
     * @type {NodeStringJsonElement}
     * @memberof NodeStringJsonElement
     */
    'parent'?: NodeStringJsonElement;
    /**
     * 
     * @type {NodeStringJsonElement}
     * @memberof NodeStringJsonElement
     */
    'left'?: NodeStringJsonElement;
    /**
     * 
     * @type {NodeStringJsonElement}
     * @memberof NodeStringJsonElement
     */
    'right'?: NodeStringJsonElement;
    /**
     * 
     * @type {NodeStringJsonElement}
     * @memberof NodeStringJsonElement
     */
    'next'?: NodeStringJsonElement;
    /**
     * 
     * @type {NodeStringJsonElement}
     * @memberof NodeStringJsonElement
     */
    'prev'?: NodeStringJsonElement;
    /**
     * 
     * @type {string}
     * @memberof NodeStringJsonElement
     */
    'key'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NodeStringJsonElement
     */
    'allowNullValue'?: boolean;
    /**
     * 
     * @type {JsonElement}
     * @memberof NodeStringJsonElement
     */
    'value'?: JsonElement;
    /**
     * 
     * @type {number}
     * @memberof NodeStringJsonElement
     */
    'height'?: number;
}
/**
 * 
 * @export
 * @interface Point
 */
export interface Point {
    /**
     * 
     * @type {string}
     * @memberof Point
     */
    'type'?: string;
    /**
     * 
     * @type {BoundingBox}
     * @memberof Point
     */
    'bbox'?: BoundingBox;
    /**
     * 
     * @type {Array<number>}
     * @memberof Point
     */
    'coordinates'?: Array<number>;
}

/**
 * GeoJsonIlotApi - axios parameter creator
 * @export
 */
export const GeoJsonIlotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Ilo Chaleur City
         * @param {string} [code] 
         * @param {boolean} [geom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCityGet: async (code?: string, geom?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/city`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (geom !== undefined) {
                localVarQueryParameter['geom'] = geom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Ilo Chaleur By Iris
         * @param {string} [code] 
         * @param {boolean} [geom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGet: async (code?: string, geom?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (geom !== undefined) {
                localVarQueryParameter['geom'] = geom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Ilo Chaleur By Iris
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShapeGet: async (code?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shape`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeoJsonIlotApi - functional programming interface
 * @export
 */
export const GeoJsonIlotApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeoJsonIlotApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Ilo Chaleur City
         * @param {string} [code] 
         * @param {boolean} [geom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCityGet(code?: string, geom?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IlotChaleur>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCityGet(code, geom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoJsonIlotApi.apiCityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Ilo Chaleur By Iris
         * @param {string} [code] 
         * @param {boolean} [geom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGet(code?: string, geom?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IlotChaleur>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGet(code, geom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoJsonIlotApi.apiGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Ilo Chaleur By Iris
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShapeGet(code?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShapeGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoJsonIlotApi.apiShapeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeoJsonIlotApi - factory interface
 * @export
 */
export const GeoJsonIlotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeoJsonIlotApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Ilo Chaleur City
         * @param {string} [code] 
         * @param {boolean} [geom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCityGet(code?: string, geom?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<IlotChaleur>> {
            return localVarFp.apiCityGet(code, geom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Ilo Chaleur By Iris
         * @param {string} [code] 
         * @param {boolean} [geom] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGet(code?: string, geom?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<IlotChaleur>> {
            return localVarFp.apiGet(code, geom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Ilo Chaleur By Iris
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShapeGet(code?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiShapeGet(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeoJsonIlotApi - object-oriented interface
 * @export
 * @class GeoJsonIlotApi
 * @extends {BaseAPI}
 */
export class GeoJsonIlotApi extends BaseAPI {
    /**
     * 
     * @summary Get Ilo Chaleur City
     * @param {string} [code] 
     * @param {boolean} [geom] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoJsonIlotApi
     */
    public apiCityGet(code?: string, geom?: boolean, options?: RawAxiosRequestConfig) {
        return GeoJsonIlotApiFp(this.configuration).apiCityGet(code, geom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Ilo Chaleur By Iris
     * @param {string} [code] 
     * @param {boolean} [geom] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoJsonIlotApi
     */
    public apiGet(code?: string, geom?: boolean, options?: RawAxiosRequestConfig) {
        return GeoJsonIlotApiFp(this.configuration).apiGet(code, geom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Ilo Chaleur By Iris
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoJsonIlotApi
     */
    public apiShapeGet(code?: string, options?: RawAxiosRequestConfig) {
        return GeoJsonIlotApiFp(this.configuration).apiShapeGet(code, options).then((request) => request(this.axios, this.basePath));
    }
}



